<template>
  <div>
    <ul class="message-list">
      <li v-for="message in messages" :key="message.ID" class="message-item">
        <div class="message-header">
          <div class="user-info">
            <img :src="avatarSrc(message.HostQQ)" alt="主人头像" class="avatar"/>
            <div class="name" v-html="message.HostQQ"></div>
            <div class="name" v-html="message.HostName"></div>
          </div>
          <div class="time">{{ formatTimestamp(message.MessageTime) }}</div>
          <div class="user-info">
            <img :src="avatarSrc(message.GuestQQ)" alt="客人头像" class="avatar"/>
            <div class="name" v-html="message.GuestQQ"></div>
            <div class="name" v-html="message.GuestName"></div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="message-text" v-html="message.HtmlMessage"></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    messages: {
      type: Array,
      required: true
    }
  },
  methods: {
    avatarSrc(qq) {
      return "https://q1.qlogo.cn/g?b=qq&nk=" + qq + "&s=100"
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
}
</script>

<style scoped>
.message-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.message-item {
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.message-item:hover {
  transform: translateY(-2px);
}

.message-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  padding: 15px;
  color: #fff;
}

.user-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-bottom: 5px;
}

.name {
  font-weight: bold;
  font-size: 1.1em;
  color: #fff;
}

.time {
  color: #ccc;
  font-size: 1em;
  text-align: center;
}

.divider {
  height: 1px;
  background-color: #eee;
}

.message-text {
  background: linear-gradient(135deg, #f0f8ff, #e6f7ff);
  padding: 15px;
  max-width: 100%;
  overflow-x: auto;
  box-sizing: border-box;
  font-size: 0.95em;
  line-height: 1.5;
  color: #333;
}
</style>
